import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LazyLoadingContentDirective } from 'ish-core/directives/lazy-loading-content.directive';
import { ModalDialogComponent, ModalOptions } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

@Component({
  selector: 'custom-mini-cart-remove-item-confirmation-modal',
  templateUrl: './custom-mini-cart-remove-item-confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomMiniCartRemoveItemConfirmationModalComponent {
  /**
   * Modal dialog options (see also @ModalDialogComponent).
   */
  @Input() options: ModalOptions;

  @Output() confirm = new EventEmitter<boolean>();

  @ViewChild('modalDialog') modal: ModalDialogComponent<unknown>;

  @ContentChild(LazyLoadingContentDirective) lazyContent: LazyLoadingContentDirective;

  shown$ = new BehaviorSubject(false);

  /** enable parent components to close the modal */
  hide() {
    this.modal.hide();
  }

  shown(): void {
    this.shown$.next(true);
  }

  closed(): void {
    this.shown$.next(false);
  }

  confirmed(): void {
    this.confirm.emit(true);
  }
}
